import { useParams } from 'react-router';
import { useGetOrderDetailsQuery } from './apiSlice';
import { useGetAccountDataQuery } from '../../navigation/apiSlice';
import { getMyPMISiteUrl } from '../../env-vars';
import { CartOrderDetails, OrderConfirmationData } from './models';
import OrderConfirmationView from './OrderConfirmationView';

const mapOrderDetailsToConfirmation = (
  orderDetails: CartOrderDetails,
  accountName?: string,
): OrderConfirmationData => {
  const { order, user, payment, billingAddress } = orderDetails;
  const items = orderDetails.items.filter((item) => item.parentId === 0);

  return {
    accountName,
    order: {
      incrementId: order?.incrementId,
      orderDate: order?.orderDate,
      currencyCode: order?.currencyCode,
      subtotal: order?.subtotal,
      taxTotal: order?.taxTotal,
      grandTotal: order?.grandTotal,
      discountTotal: order?.discountTotal,
    },
    items: items.map((item) => ({
      id: item.id,
      name: item.name,
      chapterName: item?.selectedChapter?.name,
      subtotal: item.subtotal,
    })),
    user: {
      firstName: user?.firstName ?? '',
      lastName: user?.lastName ?? '',
      email: user?.email ?? '',
    },
    payment: {
      ccType: payment?.ccType,
      ccLast4: payment?.ccLast4,
      method: payment?.method,
    },
    billingAddress: {
      firstName: billingAddress?.firstName,
      lastName: billingAddress?.lastName,
      address1: billingAddress?.address1,
      city: billingAddress?.city,
      state: billingAddress?.state,
      postalCode: billingAddress?.postalCode,
      country: billingAddress?.country,
    },
  };
};

export default function HubOrderConfirmation() {
  const { accountId, orderId } = useParams();
  const {
    data: orderDetails,
    isLoading: isLoadingOrderDetails,
    isError,
  } = useGetOrderDetailsQuery({
    accountId,
    orderId,
  });
  const { data: accountData } = useGetAccountDataQuery(accountId, {
    skip: !accountId,
  });

  const navigateToOrder = () => {
    window.location.assign(`${getMyPMISiteUrl()}/account/orders`);
  };

  if (isLoadingOrderDetails || !orderDetails) {
    return <div>Loading...</div>;
  }

  if (!isLoadingOrderDetails && isError) {
    return <div className="text-danger">Error loading order details.</div>;
  }

  const data = mapOrderDetailsToConfirmation(orderDetails, accountData?.name);

  return (
    <OrderConfirmationView
      accountId={accountId}
      data={data}
      onGoToOrders={navigateToOrder}
    />
  );
}
